// extracted by mini-css-extract-plugin
module.exports = {"form":"Forms_form__2NyvB","formValues":"Forms_form-values__2CjS6"};